import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import NavbarEnlaces from "../../../layout/NavbarEnlaces";
import "./Galeria.css";

// Ícono de Carpeta con degradado institucional
const FolderIcon = ({
  size = 150,
  fill = "url(#galeriaFolderGradient)",
  stroke = "url(#galeriaFolderGradient)",
  className = "",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    style={{ overflow: "visible" }}
    {...props}
  >
    {/* 1. Capa trasera de la carpeta con pestaña superior redondeada */}
    <path
      d="M4 4h4.5c.6 0 1.2.3 1.6.8l1.4 1.7c.4.5 1 .7 1.6.7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"
      fill={fill}
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* 2. Sombra interior bajo la solapa trasera (efecto relieve 3D) */}
    <path
      d="M2 9.5h20"
      stroke="rgba(0, 0, 0, 0.15)"
      strokeWidth="1.8"
      strokeLinecap="round"
    />

    {/* 3. Cuerpo frontal de la carpeta (bolsillo principal con relleno) */}
    <path
      d="M2 9.5C2 8.7 2.7 8 3.5 8h17c.8 0 1.5.7 1.5 1.5v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8Z"
      fill={fill}
      stroke="rgba(255, 255, 255, 0.35)"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />

    {/* 4. Sombra 3D inferior (relieve de base de la carpeta) */}
    <path
      d="M2 17.6V18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-.4c-.5.4-1.2.6-2 .6H4c-.8 0-1.5-.2-2-.6Z"
      fill="rgba(0, 0, 0, 0.18)"
    />

    {/* 5. Bisel / Línea superior de luz en blanco para volumen 3D */}
    <path
      d="M2.5 8.5h19"
      stroke="rgba(255, 255, 255, 0.65)"
      strokeWidth="1"
      strokeLinecap="round"
    />
  </svg>
);

export const Galeria = () => {
  useEffect(() => {
    document.title = `Galeria`;
  }, []);
  return (
    <>
      <svg
        width="0"
        height="0"
        style={{ position: "absolute", pointerEvents: "none" }}
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="galeriaFolderGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#C2189E" />
            <stop offset="100%" stopColor="#8E3AA8" />
          </linearGradient>
        </defs>
      </svg>
      <div className="margin-bottom-2">
        <NavbarEnlaces title="Galería Fotográfica" />
        <div className="Grid__folder">
          {/* <div>
            <Link to="/Galeria2016">
              <img
                className="img-fluid"
                src="https://itetlax.org.mx/assets/img/icons/29.png"
                alt="Galería Fotográfica 2016"
              />
            </Link>
          </div>
          <div>
            <Link to="/Galeria2017">
              <img
                className="img-fluid"
                src="https://itetlax.org.mx/assets/img/icons/30.png"
                alt="Galería Fotográfica 2017"
              />
            </Link>
          </div>
          <div>
            <Link to="/Galeria2018">
              <img
                className="img-fluid"
                src="https://itetlax.org.mx/assets/img/icons/31.png"
                alt="Galería Fotográfica 2018"
              />
            </Link>
          </div>
          <div>
            <Link to="/Galeria2019">
              <img
                className="img-fluid"
                src="https://itetlax.org.mx/assets/img/icons/32.png"
                alt="Galería Fotográfica 2019"
              />
            </Link>
          </div> */}
          <div>
            <Link to="/Galeria2024" className="Galeria__link">
              <div className="Galeria__folderWrapper">
                <FolderIcon
                  fill="url(#galeriaFolderGradient)"
                  size={150}
                  className="Galeria__folderIcon"
                />
                <span className="Galeria__yearText">2024</span>
              </div>
            </Link>
          </div>
          <div>
            <Link to="/Galeria2025" className="Galeria__link">
              <div className="Galeria__folderWrapper">
                <FolderIcon
                  fill="url(#galeriaFolderGradient)"
                  size={150}
                  className="Galeria__folderIcon"
                />
                <span className="Galeria__yearText">2025</span>
              </div>
            </Link>
          </div>
          <div>
            <Link to="/Galeria2026" className="Galeria__link">
              <div className="Galeria__folderWrapper">
                <FolderIcon
                  fill="url(#galeriaFolderGradient)"
                  size={150}
                  className="Galeria__folderIcon"
                />
                <span className="Galeria__yearText">2026</span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Galeria;
